import {
  filter_all,
  filter_last_30_days,
  filter_last_month,
  filter_last_week,
  filter_this_month,
  filter_this_week,
  filter_today,
  filter_yesterday,
} from '../../../../../components/filters/DateRangePicker';

export default {
  filters: {
    [filter_today]: 'Tänään',
    [filter_yesterday]: 'Eilen',
    [filter_this_week]: 'Tällä viikolla',
    [filter_last_week]: 'Viime viikolla',
    [filter_this_month]: 'Tässä kuussa',
    [filter_last_month]: 'Viime kuussa',
    [filter_last_30_days]: 'Viimeiset 30 päivää',
    [filter_all]: 'Kaikki',
  },
};
